import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { BookingResponse } from 'app/typings/core/admin/bookings/booking';
import type { UpdateBookingRequest } from 'app/typings/core/admin/bookings/bookingForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type UpdateBookingParams = {
  code: string;
  payload: UpdateBookingRequest;
};

export function useUpdateBooking() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ code, payload }: UpdateBookingParams) =>
      apiMutation(
        'PATCH',
        { path: ENDPOINTS.updateBooking, params: { bookingCode: code } },
        payload
      ) as Promise<BookingResponse>,
    onSuccess: (response, variables) => {
      message.success('Booking successfully updated');

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.booking, { code: variables.code }],
        response
      );
    },
    onError: () => {
      message.error('Failed to update booking');
    },
  });
}
